import { render, staticRenderFns } from "./MoreFilter.vue?vue&type=template&id=81fc84de&scoped=true&"
import script from "./MoreFilter.vue?vue&type=script&lang=js&"
export * from "./MoreFilter.vue?vue&type=script&lang=js&"
import style0 from "./MoreFilter.vue?vue&type=style&index=0&id=81fc84de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fc84de",
  null
  
)

export default component.exports